module.exports = __webpack_public_path__ + "img/close-icon.727dedf1.svg";